import { render, staticRenderFns } from "./SimpleCover.vue?vue&type=template&id=685e4ba9&scoped=true&"
import script from "./SimpleCover.vue?vue&type=script&lang=ts&"
export * from "./SimpleCover.vue?vue&type=script&lang=ts&"
import style0 from "./SimpleCover.vue?vue&type=style&index=0&id=685e4ba9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685e4ba9",
  null
  
)

export default component.exports